import { H1 } from '@payaca/ambrosia';
import CreateServicePlanDiscountCodeControl from '@/ui/components/createServicePlanDiscountCode/CreateServicePlanDiscountCodeControl';
import AuthenticatedPageWrapper from '@/ui/layouts/authenticatedPageWrapper/AuthenticatedPageWrapper';
import { FC } from 'react';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router';

const NewDiscountCodePage: FC = () => {
  const history = useHistory();

  return (
    <>
      <Helmet title={'New discount code'} />

      <AuthenticatedPageWrapper
        className="service-plan-page"
        breadcrumbItems={[
          { label: 'Back', to: '/service-plans/discount-codes' },
          { label: 'New discount code' },
        ]}
      >
        <div className="px-8 py-4">
          <H1>New service plan discount code</H1>
        </div>
        <div className="p-4">
          <CreateServicePlanDiscountCodeControl
            onCreateSuccess={() =>
              history.push(`/service-plans/discount-codes`)
            }
          />
        </div>
      </AuthenticatedPageWrapper>
    </>
  );
};

export default NewDiscountCodePage;
